module.exports = __webpack_public_path__ + "static/media/stm-21st-mobile-822x186-@2x.0e66db61.webp";